export enum AddressType {
    current,
    home,
    registered
}
